<div class="login-header">
    <div class="header-logo">
        <img [src]="utilityLogo || '../../../assets/logo.svg'" alt="Logo" />
    </div>
    <div class="header-x" [routerLink]="['']">
        <img src="../../../assets/solid.svg" alt="" />
    </div>
</div>